"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var normalize = function (str) {
    return str
        .toLowerCase()
        .replace(/\W+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '') || '-';
};
exports.normalize = normalize;
var getKey = function (host, path) { return ['external', 'http', normalize(host), normalize(path)].join('.'); };
exports.getKey = getKey;
//# sourceMappingURL=telemetryHelpers.js.map